import { Masonry } from '@mui/lab';

function AppMasonry(props: React.ComponentProps<typeof Masonry>) {
  return <Masonry {...props} />;
}

export { AppMasonry };
